import React from 'react';
import { useTranslation } from 'react-i18next';

const CreatorAgreement: React.FC = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 min-h-[calc(100vh-200px)]">
      {/* Meta */}
      <div className="flex items-start justify-between mb-4">
        <h1 className="text-3xl font-bold">{t('creatorAgreement.title')}</h1>
        <div className="text-right">
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded mr-2">{t('creatorAgreement.lastUpdated')}</span>
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded">{t('creatorAgreement.version')}</span>
        </div>
      </div>

      {/* Intro */}
      <p className="text-gray-700 mb-6">
        {t('creatorAgreement.intro')}
      </p>

      {/* Sections */}
      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec1.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec1.text')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec2.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec2.text')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec3.title')}</h2>
          <p className="text-gray-700 mb-2">{t('creatorAgreement.sec3.intro')}</p>
          <ul className="list-disc pl-6 text-gray-700 space-y-1">
            <li>{t('creatorAgreement.sec3.item1')}</li>
            <li>{t('creatorAgreement.sec3.item2')}</li>
            <li>{t('creatorAgreement.sec3.item3')}</li>
            <li>{t('creatorAgreement.sec3.item4')}</li>
            <li>{t('creatorAgreement.sec3.item5')}</li>
            <li>{t('creatorAgreement.sec3.item6')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec4.title')}</h2>
          <p className="text-gray-700 mb-2">{t('creatorAgreement.sec4.platformPromo')}</p>
          <p className="text-gray-700 mb-2">{t('creatorAgreement.sec4.restriction')}</p>
          <p className="text-gray-700">{t('creatorAgreement.sec4.furtherUse')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec5.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec5.text')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec6.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec6.text')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec7.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec7.text')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec8.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec8.text')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec9.title')}</h2>
          <p className="text-gray-700 mb-2">{t('creatorAgreement.sec9.text1')}</p>
          <p className="text-gray-700 mb-2">{t('creatorAgreement.sec9.text2')}</p>
          <p className="text-gray-700">{t('creatorAgreement.sec9.text3')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec10.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec10.text')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec11.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec11.text')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec12.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec12.text')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">{t('creatorAgreement.sec13.title')}</h2>
          <p className="text-gray-700">{t('creatorAgreement.sec13.text')}</p>
        </section>
      </div>

      {/* Footer */}
      <div className="mt-8 pt-6 border-t border-gray-200">
        <p className="text-gray-600">{t('creatorAgreement.footer')}</p>
      </div>
    </div>
  );
};

export default CreatorAgreement;

